import { SignInWithGoogleButton } from "@vellum/ui";
import { getGoogleLoginUrl } from "@vellum/micro-app-auth";

export function LoginPage() {
  return (
    <div className="flex justify-center">
      <div className="w-full md:w-2xl rounded-md border border-gray-200 bg-white p-6 shadow-sm text-center">
        <h1 className="mb-2 text-2xl font-bold text-green-700">Sign in</h1>
        <p className="mb-6 text-xs md:text-sm leading-relaxed text-gray-600">
          Use your Vellum Health Google account to continue.
        </p>
        <SignInWithGoogleButton href={getGoogleLoginUrl()} />
      </div>
    </div>
  );
}
